import '.c3{position:relative;}.ssr-plugin'
import '.i2{width:64px;}.ssr-plugin'
import '.i3{height:64px;}.ssr-plugin'
import '.bx{flex-shrink:0;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.i4{bottom:-4px;}.ssr-plugin'
import '.co{right:-4px;}.ssr-plugin'
import '.dl{border-radius:50%;}.ssr-plugin'
import '.i5{border:2px solid var(--shades-white);}.ssr-plugin'
import '.a6{overflow:hidden;}.ssr-plugin'
import '.i6{width:32px;}.ssr-plugin'
import '.i7{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c3 i2 i3 bx"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="a2 i4 co dl i5 a6 i6 i7"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
